import { api } from "../lib";

export interface SourceDefaultStain {
  id: string;
  stainId: string;
  stainCode: string;
  stainName: string;
  markAsCompleted: boolean;
}

export async function getSourceDefaultStains(
  sourceId: string,
  finding?: string,
  subsiteId?: string,
  practiceId?: string,
  billingScenarioId?: string,
  casePrefix?: string,
  isProcessedMaterial?: boolean
): Promise<SourceDefaultStain[]> {
  const params = new URLSearchParams();
  if (finding) params.append("finding", finding);
  if (subsiteId) params.append("subsiteId", subsiteId);
  if (practiceId) params.append("practiceId", practiceId);
  if (billingScenarioId) params.append("billingScenarioId", billingScenarioId);
  if (casePrefix) params.append("casePrefix", casePrefix);
  if (isProcessedMaterial)
    params.append("isProcessedMaterial", String(isProcessedMaterial));

  const queryString = params.toString();
  const url = `/reference/sources/${sourceId}/default-stains${
    queryString ? `?${queryString}` : ""
  }`;

  return api.get<SourceDefaultStain[]>(url);
}
